import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";

import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Select from "react-select";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../../helpers/units";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import printDiv from "../../../../helpers/print_data";
import UpdateQuantityModal from "../../../../components/UpdateQuantityModal";

const ItemAllOrdersByBranch = (props) => {
  const storename = localStorage.getItem("store_name");
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);
  useEffect(() => {
    loadAllBranches();
    loadAllCategories();
  }, []);
  const [confirmClose, setConfirmClose] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const [isDispatched, setIsDispatched] = useState(false);

  useEffect(() => {
    loadAllOrders();
  }, [selectedCategory, selectedBranch]);

  const [allOrders, setAllOrders] = useState([]);
  const loadAllOrders = async () => {
    const daysDiff = moment(dateTo).diff(dateFrom, "days");
    if (daysDiff > 31) {
      setAllOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (daysDiff < 0) {
      setAllOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }

    preloader(true);
    setAllOrders([]);
    let allData = [];
    const url = process.env.REACT_APP_BASEURL + "itemorders/getall";

    // If the date range is more than 5 days, split it into 4 parts
    if (daysDiff > 5) {
      const daysPerPart = Math.ceil(daysDiff / 4);
      let startDate = moment(dateFrom);
      let endDate = moment(dateTo);

      for (let i = 0; i < 4; i++) {
        const currentEndDate = moment.min(
          startDate.clone().add(daysPerPart, "days"),
          endDate,
        );

        const response = await postSubmitForm(url, {
          date_from: startDate.format("YYYY-MM-DD"),
          date_to: currentEndDate.format("YYYY-MM-DD"),
          status: [
            "Approved",
            "Dispatched",
            "PO is pending",
            "Partially Dispatched",
            // "Received",
            "Delivered",
            "Partially Received",
            "Closed",
          ],
          branch: selectedBranch,
          category: selectedCategory,
        });

        if (response && response.status === 1) {
          let filtered = response.data.filter((item) =>
            item.order_for
              ? item.order_for !== "substore deficit" &&
                item.substore_dispatch?.length > 0
              : " ",
          );
          allData = [...allData, ...filtered];
        } else {
          //  showNotification(response.message || "Error", "Error");
        }

        startDate = currentEndDate.clone().add(1, "day");
        if (startDate.isAfter(endDate)) break;
      }
    } else {
      // Single API call if days difference is 5 or less
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
        status: [
          "Approved",
          "Dispatched",
          "PO is pending",
          "Partially Dispatched",
          "Delivered",
          "Partially Received",
          // "Received",
          "Closed",
        ],
        branch: selectedBranch,
        category: selectedCategory,
      });

      if (response && response.status === 1) {
        let filtered = response.data.filter((item) =>
          item.order_for
            ? item.order_for !== "substore deficit" &&
              item.substore_dispatch.length > 0
            : " ",
        );
        allData = [...allData, ...filtered];
      } else {
        showNotification(response.message || "Error", "Error");
        preloader(false);
        return;
      }
    }

    preloader(false);
    if (allData.length <= 0) {
      showNotification("No Orders data found", "error");
    }
    setAllOrders(allData);
  };

  const [allBranches, setAllBranches] = useState([]);
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter(
        (store) =>
          store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE",
      );
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "order_to",
      text: props.t("Order To"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("From Supplier"),
      dataField: "direct_po",
      formatter: (cell, row) => {
        return row.direct_po ? "Yes" : "No";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Branch Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Ordered Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "sub_store_available",
      text: props.t("Sub Store Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.sub_store_available, row.unit_levels);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const [selectedOrder, setSelectedOrder] = useState();
  const handleCloseOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/set_closed";
    const response = await postSubmitForm(url, {
      itemorder_id: selectedOrder._id,
      admin_remarks: adminRemarks,
    });

    if (response && response.status === 1) {
      setAdminRemarks("");
      loadAllOrders();
      setRemarksModal(!remarksModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [remarksModal, setRemarksModal] = useState();
  const [adminRemarks, setAdminRemarks] = useState();
  const [detailsModal, setDetailsModal] = useState(false);

  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Branch Name"),

      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },

      dataField: "createdAt",
      // formatter: (cell, row) => {
      //   return moment(row.createdAt).format("DD-MM-YYYY HH:mm");
      // },
      style: { cursor: "pointer" },
    },

    {
      dataField: "substore_status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Details"),
      formatter: (cell, row) => {
        return (
          <span className="text-info">
            <i
              className="mdi mdi-text-box-search font-size-15"
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDetailsModal(!detailsModal);
                setSelectedOrder(row);
              }}
            ></i>
          </span>
        );
      },
      csvExport: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            {row.substore_status !== "Closed" ? (
              <>
                <button
                  class="btn btn-secondary btn-sm mr-2"
                  onClick={() => {
                    setSelectedOrder(row);
                    setItemsForDelivery([]);
                    setSelectedItem();
                    setSelectedBatch();
                    loadItemsInOrder(row._id);
                    setOrderDispatchModal(!orderDispatchModal);
                    if (row.substore_status !== "Closed") {
                      setIsPartialDelivery(false);
                      handleSetItemsForFullDelivery(row.to_deliver);
                    } else if (row.substore_status === "Partially Received")
                      if (row.substore_status === "Closed") {
                        // setIsPartialDelivery(true)
                        // handleSetItemsForFullDelivery(row.substore_dispatch);
                        // setSubStoreAvailableStatus(row.central_available_status);
                        setIsDispatched(true);
                      } else {
                        setIsDispatched(false);
                      }
                  }}
                >
                  {props.t("Dispatch")}
                </button>
                <button
                  class="btn btn-danger btn-sm mr-2"
                  onClick={() => {
                    setRemarksModal(!remarksModal);
                    setSelectedOrder(row);
                  }}
                >
                  {props.t("Close")}
                </button>
              </>
            ) : (
              "No Action Required"
            )}
            {/* <button
              class="btn btn-info btn-sm mr-2"
              onClick={() => {
                setEditModal(!editModal);
                loadItemsInOrder(row._id);
                setItemsForOrder(row.item_details);
                setSelectedOrder(row);
              }}
            >
              {props.t("Edit")}
            </button> */}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
  ];

  const handleSetItemsForFullDelivery = async (items) => {
    //  let filtered = items.filter(item => item.dispatch_quantity?.some(unit => unit.value != 0))  || []

    if (items.length > 0) {
      let new_arr = items.map((item) => {
        let obj = {
          name: item.name,
          category: item.category,
          sub_category: item.sub_category,
          item_id: item.item_id,
          quantity: item.quantity,
          direct_po: item.direct_po,
          initial_order_quantity: item.initial_order_quantity,
          delivered_quantity: item.dispatch_quantity?.map(
            ({ unit, value }) => ({ unit, value }),
          ),
          sub_store_available: item.sub_store_available,
          brand: item.brand,
          unit_levels: item.unit_levels,
        };
        return obj;
      });
      setItemsForDelivery(new_arr);
    } else {
      setItemsForDelivery([]);
    }
  };

  const [editModal, setEditModal] = useState(false);
  function EditFormatter(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(
              row.delivered_quantity && row.delivered_quantity,
              row.unit_levels,
            )}
          </span>
          {selectedOrder.substore_status !== "Closed" && (
            <Button
              className="btn btn-success btn-sm"
              onClick={() => {
                let updatedItem = {
                  ...row,
                  quantity: row.delivered_quantity?.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setEditModal(true);
              }}
            >
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }

  const handleSubmit = (quantity) => {
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    let filtere = convertedQuantity.map(({ unit, value }) => ({
      unit,
      value: +value,
    }));
    const updatedItems = itemsForDelivery.map((item) => {
      if (item.item_id === selectedItem.item_id) {
        return { ...item, delivered_quantity: filtere };
      }
      return item;
    });
    setEditModal(false);
    setSelectedItem();
    setItemsForDelivery(updatedItems);
  };

  const columns_fulldelivery = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity, row.unit_levels);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Deliver Qty."),
      formatter: EditFormatter,
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "sub_store_available",
      text: props.t("Sub Store Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.sub_store_available, row.unit_levels);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.substore_status === "Dispatched") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.substore_status === "Partially Received") {
      style.backgroundColor = "#bb87cc";
    } else {
      style.backgroundColor = "#fffbb8";
    }
    return style;
  };
  //#region Dispatch order related code
  const [itemsForDelivery, setItemsForDelivery] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [orderDispatchModal, setOrderDispatchModal] = useState();
  const [itemBatches, setItemBatches] = useState();
  const [selectedBatch, setSelectedBatch] = useState();
  const [allItems, setAllItems] = useState([]);
  const loadItemsInOrder = async (itemorder_id) => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/get_items_in_order";
    const response = await postSubmitForm(url, { itemorder_id });
    if (response && response.status === 1) {
      setAllItems(response.data);
    } else {
      console.log(response.message, "Error");
    }
  };
  const validateItemDispatch = (item) => {
    const availableQty = convertToLowestUnit(
      item.unit_levels,
      item.sub_store_available || [],
    );
    const dispatchQty = convertToLowestUnit(
      item.unit_levels,
      item.delivered_quantity || [],
    );
    if (dispatchQty > availableQty) {
      return {
        isValid: false,
        message: `Dispatch quantity for <strong>${item.name}</strong > exceeds store available quantity.`,
      };
    }

    return { isValid: true };
  };
  const loadBatches = async (item_details) => {
    let url =
      process.env.REACT_APP_BASEURL + "storeiteminventories/get_for_delivery";
    const response = await postSubmitForm(url, {
      item_id: item_details.value,
    });
    if (response && response.status === 1) {
      setItemBatches(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns_delivered_items = [
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Delivered Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(
          row.received_quantity && row.received_quantity,
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Received by Branch?"),
      dataField: "is_received",
      formatter: (cell, row) => {
        return row.is_received ? "Yes" : "No";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  const handleDispatchOrder = async () => {
    let isValid = true;
    if (isDispatched) {
      return showNotification("Already dispatched.", "Error");
    }
    if (itemsForDelivery.length > 0) {
      for (const item of itemsForDelivery) {
        const validationResult = validateItemDispatch(item);
        if (!validationResult.isValid) {
          isValid = false;
          showNotification(validationResult.message, "Warning");
          return;
        }
      }
      setIsDispatched(true);
      let data_to_send = {};
      data_to_send.itemorder_id = selectedOrder._id;
      data_to_send.branch_id = selectedOrder.branch_details._id;
      data_to_send.delivery_details = itemsForDelivery;
      data_to_send.isPartialDelivery = false;
      let url = process.env.REACT_APP_BASEURL + "itemorders/dispatch";
      // console.log(data_to_send);return
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        setIsDispatched(false);
        loadAllOrders();
        showNotification(response.message, "Success");
        setOrderDispatchModal(!orderDispatchModal);
      } else {
        setIsDispatched(false);
        showNotification(response.message, "Error");
      }
    } else {
      setIsDispatched(false);
      showNotification("Add at least one item.", "Error");
    }
  };
  //#endregion

  const [isPartialDelivery, setIsPartialDelivery] = useState(false);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleSelectBatch(e) {
    setSelectedBatch(e);
  }

  const substoreDispatched = selectedOrder?.delivery_details.some(
    (item) => item.delivered_from === storename,
  );
  // const showDispatch = selectedOrder?.to_deliver?.some(item => item.is_dispatchable)
  const showDispatch =
    selectedOrder?.substore_status !== "Closed" &&
    selectedOrder?.substore_status !== "Dispatched" &&
    selectedOrder?.substore_status !== "Partially Dispatched";
  function getData() {
    let substore_dispatched = [];
    let delivery_details = selectedOrder?.delivery_details || [];
    delivery_details.map((item) => {
      if (item.delivered_from === storename) {
        substore_dispatched.push(item);
      }
    });
    return substore_dispatched;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Sub Store")}
            breadcrumbItem1={props.t("Item Order")}
            breadcrumbItem2={props.t("Orders In Process")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Orders In Process")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all orders in process here")}
                  </CardSubtitle>

                  <ToolkitProvider
                    keyField="_id"
                    data={allOrders && allOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <Label>{props.t("Search")}</Label>
                              <SearchBar
                                {...props_table.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="branch"
                                label={props.t("Branch")}
                                type="select"
                                value={selectedBranch}
                                onChange={(e) => {
                                  setSelectedBranch(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allBranches &&
                                  allBranches.map((branch) => {
                                    return (
                                      <option value={branch._id}>
                                        {branch.name}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="category"
                                label={props.t("Category")}
                                type="select"
                                value={selectedCategory}
                                onChange={(e) => {
                                  setSelectedCategory(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allCategories &&
                                  allCategories.map((category) => {
                                    return (
                                      <option value={category.category}>
                                        {category.category}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          // expandRow={expandRow}
                          rowStyle={rowStyle}
                          {...props_table.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>

                  {/* Dispatch Modal  */}
                  <Modal
                    size="lg"
                    style={{ width: "1200px", minWidth: "1200px" }}
                    isOpen={orderDispatchModal}
                    toggle={() => setOrderDispatchModal(!orderDispatchModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDispatchModal(!orderDispatchModal)}
                    >
                      {props.t("Dispatch Order")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        printDiv("printOrdered");
                                      }}
                                      className="btn btn-sm btn-success mr-2"
                                    >
                                      <i className="fa fa-print"></i> Print
                                    </Link>
                                    <div id="printOrdered">
                                      <Col lg={12} md={12}>
                                        <Label>Ordered Items</Label>
                                      </Col>

                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          data={
                                            selectedOrder &&
                                            selectedOrder.item_details
                                          }
                                          columns={columns}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />

                                        <hr />
                                      </Col>
                                    </div>
                                  </Col>

                                  {selectedOrder &&
                                  selectedOrder.delivery_details &&
                                  selectedOrder.delivery_details.length > 0 &&
                                  substoreDispatched ? (
                                    <>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          printDiv("printDispatched");
                                        }}
                                        className="btn btn-sm btn-success mr-2"
                                      >
                                        <i className="fa fa-print"></i> Print
                                      </Link>
                                      <div id="printDispatched">
                                        <Col lg={12} md={12}>
                                          <Label>
                                            <b>
                                              {props.t(
                                                "Dispatched Items from Sub Store",
                                              )}{" "}
                                            </b>
                                          </Label>
                                        </Col>
                                        <Col lg={12} className="mb-4">
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="_id"
                                            data={getData()}
                                            columns={columns_delivered_items}
                                            noDataIndication="No data to display."
                                            striped
                                            hover
                                            condensed
                                          />
                                          <hr />
                                        </Col>
                                      </div>
                                    </>
                                  ) : null}
                                </Row>
                                {isPartialDelivery && (
                                  <Col
                                    lg={12}
                                    hidden={
                                      selectedOrder?.substore_status ===
                                      "Closed"
                                    }
                                  >
                                    <AvForm
                                      onValidSubmit={() =>
                                        setSelectUnitModal(!selectUnitModal)
                                      }
                                    >
                                      <Row>
                                        <Col lg={4}>
                                          <Label>{props.t("Add Item")}</Label>
                                          <Select
                                            value={selectedItem && selectedItem}
                                            key={selectedItem}
                                            placeholder={props.t("Select...")}
                                            onChange={(e) => {
                                              setSelectedItem(e);
                                              loadBatches(e);
                                              setSelectedBatch();
                                            }}
                                            options={allItems}
                                            classNamePrefix="select2-selection"
                                            required
                                          />
                                        </Col>
                                        <Col lg={4}>
                                          <Label>{props.t("Batch")}</Label>
                                          <Select
                                            // ref={refSelectedBatch}
                                            value={
                                              selectedBatch && selectedBatch
                                            }
                                            key={selectedBatch}
                                            onChange={(e) => {
                                              handleSelectBatch(e);
                                            }}
                                            options={itemBatches && itemBatches}
                                            classNamePrefix="select2-selection"
                                            required
                                          />
                                        </Col>

                                        <Col lg={2} className="mb-4">
                                          <Label>&nbsp;</Label>
                                          <br />
                                          <Button
                                            type="submit"
                                            color="primary"
                                            className="btn btn-info waves-effect waves-light btn-sm"
                                          >
                                            <i class="bx bx-add-to-queue"></i>{" "}
                                            {props.t("Add")}
                                          </Button>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </Col>
                                )}
                                <Row>
                                  {showDispatch &&
                                  itemsForDelivery &&
                                  itemsForDelivery.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>
                                            {props.t(
                                              `Items to Deliver from ${storename}`,
                                            )}{" "}
                                          </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={
                                            itemsForDelivery && itemsForDelivery
                                          }
                                          columns={columns_fulldelivery}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                      </Col>
                                      <Col lg={12}>
                                        <hr />
                                        <FormGroup className="mb-0 text-center">
                                          <div>
                                            <Button
                                              onClick={handleDispatchOrder}
                                              color="primary"
                                              className="mr-1"
                                              style={{ width: "100px" }}
                                              disabled={isDispatched}
                                            >
                                              {isDispatched ? (
                                                <Spinner size="sm" />
                                              ) : (
                                                props.t("Dispatch")
                                              )}
                                            </Button>
                                          </div>
                                        </FormGroup>
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>

                  <Modal
                    size="md"
                    isOpen={remarksModal}
                    toggle={() => setRemarksModal(!remarksModal)}
                  >
                    <ModalHeader toggle={() => setRemarksModal(!remarksModal)}>
                      Order ID: {selectedOrder && selectedOrder.order_id}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <AvForm
                                  onValidSubmit={(e, v) =>
                                    setConfirmClose(true)
                                  }
                                >
                                  <Row>
                                    <Col lg={12}>
                                      <AvField
                                        name="admin_remarks"
                                        placeholder="Enter remarks"
                                        type="textarea"
                                        onChange={(e) =>
                                          setAdminRemarks(e.target.value)
                                        }
                                        value={adminRemarks}
                                        label="Remarks"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "Remarks cannot be empty.",
                                          },
                                        }}
                                      />
                                    </Col>

                                    <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            type="submit"
                                            color="primary"
                                            className="mr-1"
                                          >
                                            {props.t("Submit")}
                                          </Button>{" "}
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </AvForm>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>

                  {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleCloseOrder();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t(
                        "Once you close this order, it cannot be revoked.",
                      )}
                    </SweetAlert>
                  )}

                  {/* Details MOdal  */}

                  <Modal
                    size="lg"
                    style={{ width: "1200px", minWidth: "1200px" }}
                    isOpen={detailsModal}
                    toggle={() => {
                      setDetailsModal(!detailsModal);
                    }}
                  >
                    <ModalHeader
                      toggle={() => {
                        setDetailsModal(!detailsModal);
                      }}
                    >
                      {props.t("Order Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        printDiv("printOrdered");
                                      }}
                                      className="btn btn-sm btn-success mr-2"
                                    >
                                      <i className="fa fa-print"></i> Print
                                    </Link>
                                    <div id="printOrdered">
                                      <Col lg={12} md={12}>
                                        <Label>Ordered Items</Label>
                                      </Col>

                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          data={
                                            selectedOrder &&
                                            selectedOrder.item_details
                                          }
                                          columns={columns}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />

                                        <hr />
                                      </Col>
                                    </div>
                                  </Col>

                                  {selectedOrder &&
                                  selectedOrder.delivery_details &&
                                  selectedOrder.delivery_details.length > 0 &&
                                  substoreDispatched ? (
                                    <>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          printDiv("printDispatched");
                                        }}
                                        className="btn btn-sm btn-success mr-2"
                                      >
                                        <i className="fa fa-print"></i> Print
                                      </Link>
                                      <div id="printDispatched">
                                        <Col lg={12} md={12}>
                                          <Label>
                                            <b>
                                              {props.t(
                                                "Dispatched Items from Sub Store",
                                              )}{" "}
                                            </b>
                                          </Label>
                                        </Col>
                                        <Col lg={12} className="mb-4">
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="_id"
                                            data={getData()}
                                            columns={columns_delivered_items}
                                            noDataIndication="No data to display."
                                            striped
                                            hover
                                            condensed
                                          />
                                          <hr />
                                        </Col>
                                      </div>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>

                  {/* Update Deliver Quantity*/}

                  <UpdateQuantityModal
                    isOpen={editModal}
                    toggle={() => setEditModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedItem}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(ItemAllOrdersByBranch)),
);
